import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Observable } from 'rxjs';
import { CustoMedio } from '../api/dto/custo-medio';

@Injectable({
    providedIn: 'root'
})
export class CustoService {

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'custos';


    obterDadosParaPrecificacao(empresaId?: number): Observable<CustoMedio> {
        return this.http.get<CustoMedio>(`${this.url}/custo-medio/empresa/${empresaId}`);
    }

}